// reemplazá todo el contenido del componente actual con este

import { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { api } from "../services/api";
import { Link } from "react-router-dom";

const AdminSessionRefunds = () => {
  const [refunds, setRefunds] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortDir, setSortDir] = useState("desc");
  const [page, setPage] = useState(1);
  const limit = 20;

  const fetchRefunds = async () => {
    const params = new URLSearchParams({
      page,
      limit,
      sort_by: sortBy,
      sort_dir: sortDir,
      ...(search.trim() && (!isNaN(search.trim()) ? { user_id: search.trim() } : { q: search.trim() }))
    }).toString();

    const res = await api.get(`/api/admin/refunds/list?${params}`);
    setRefunds(res.data.refunds);
    setTotal(res.data.total);
  };

  useEffect(() => {
    fetchRefunds();
  }, [page, sortBy, sortDir]);

  const totalPages = Math.ceil(total / limit);

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortDir("asc");
    }
  };

  return (
    <Box sx={{
      backgroundImage: 'url("/assets/bg-pitchest.jpg")',
      backgroundSize: "cover",
      minHeight: "100vh",
      px: 2,
      py: 6,
    }}>
      <Box
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          borderRadius: 4,
          padding: { xs: 2, md: 4 },
          color: "white",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h5">💸 Session Refunds</Typography>
          <Link to="/admin" style={{ color: "#90caf9", fontWeight: "bold" }}>⬅ Back</Link>
        </Box>

        <Typography variant="body2" sx={{ mb: 2 }}>
          Total: {total} — Page {page} of {totalPages}
        </Typography>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
          <Box>
            <label style={{ marginRight: 8 }}>Search:</label>
            <input
              type="text"
              placeholder="Email, name or user ID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setPage(1);
                  fetchRefunds();
                }
              }}
              style={{
                padding: "6px 10px",
                width: 250,
                borderRadius: 4,
                border: "1px solid #888",
                backgroundColor: "#222",
                color: "#fff"
              }}
            />
            <Button
              variant="outlined"
              onClick={() => {
                setPage(1);
                fetchRefunds();
              }}
              size="small"
              sx={{ ml: 1 }}
            >
              🔍 Search
            </Button>
          </Box>
        </Box>

        <Box sx={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", color: "white" }}>
            <thead>
              <tr>
                {[
                  { label: "Date", field: "created_at" },
                  { label: "User Email", field: "user_email" },
                  { label: "Session ID", field: "pitch_session_id" },
                  { label: "Reason", field: "reason" },
                  { label: "Source", field: "session_source_type" }
                ].map(({ label, field }) => (
                  <th
                    key={field}
                    onClick={() => handleSort(field)}
                    style={{
                      cursor: "pointer",
                      padding: "8px",
                      backgroundColor: "#34163A"
                    }}
                  >
                    {label} {sortBy === field && (sortDir === "asc" ? "▲" : "▼")}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {refunds.map((r, idx) => (
                <tr key={r.id} style={{ backgroundColor: idx % 2 === 0 ? "#5E2F6E" : "transparent" }}>
                  <td style={{ padding: "8px", textAlign: "center" }}>{new Date(r.created_at).toLocaleString()}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{r.user?.email}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{r.pitch_session_id}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{r.reason}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{r.session_source_type} #{r.session_source_id}</td>
                </tr>
              ))}
             {refunds.length === 0 && (
                <tr>
                  <td colSpan={6} style={{ padding: "16px", textAlign: "center", backgroundColor: "#452654" }}>
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Box>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="outlined" disabled={page === 1} onClick={() => setPage(page - 1)}>⬅ Prev</Button>
          <Button variant="outlined" disabled={page >= totalPages || refunds.length === 0} onClick={() => setPage(page + 1)}>Next ➡</Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminSessionRefunds;
